import { createContext } from "react";

import type { UXSimplificationFlag } from "./UXFeatureFlags";

/**
 * This is to support the other UX simplification hooks/components.
 * You need to use the toggle in `UXFeatureFlags` instead.
 *
 * @example
 * ```tsx
 * const { setUXSimplificationFlag } = useUXSimplificationFeature();
 * ```
 */
type StylesheetsContextValueType = (flag: UXSimplificationFlag) => void;

export default createContext<StylesheetsContextValueType>(() => {
	throw new Error("useSetUXSimplificationStylesheets must be used within a StylesheetsProvider");
});
